import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Grid, Text } from 'onefaceui-react-components';

import { getResourceTo } from 'react/utils/utils';
import { useRoutePermissions } from './hooks/useRoutePermissions';
import Assignments from '../components/Assignments';

/**
 * Component that handles the display of all route assignments
 * Following the Single Responsibility Principle
 */
function RouteAssignments({
  driverAssignments,
  equipmentAssignments,
  tagAssignments,
  onClickOnEditDrivers,
  onClickOnEditEquipments,
  onClickOnEditTags
}) {
  const { getAssignmentPermissions } = useRoutePermissions();

  const driverPermissions = getAssignmentPermissions('driver');
  const equipmentPermissions = getAssignmentPermissions('equipment');
  const tagPermissions = getAssignmentPermissions('tag');

  return (
    <Flex flexDirection="column">
      <Text type="primary" size="xs">
        {getResourceTo('routePanel.routeAssignments.title')}
      </Text>
      <Grid templateColumns="1fr 1.2fr 1fr">
        <Assignments
          type="driver"
          assignments={driverAssignments}
          extractor={(item) => item.driver.name}
          onClickOnEdit={onClickOnEditDrivers}
          disableEditAssign={!driverPermissions.canEditAssignment}
          disableEditItem={!driverPermissions.canEditItem}
        />
        <Assignments
          type="equipment"
          assignments={equipmentAssignments}
          extractor={(item) => item.equipment.key}
          onClickOnEdit={onClickOnEditEquipments}
          disableEditAssign={!equipmentPermissions.canEditAssignment}
          disableEditItem={!equipmentPermissions.canEditItem}
        />
        {tagPermissions.canEditAssignment || tagPermissions.canEditItem ? (
          <Assignments
            type="tag"
            assignments={tagAssignments}
            extractor={(item) => item.tag.description}
            onClickOnEdit={onClickOnEditTags}
            disableEditAssign={!tagPermissions.canEditAssignment}
            disableEditItem={!tagPermissions.canEditItem}
          />
        ) : null}
      </Grid>
    </Flex>
  );
}

RouteAssignments.propTypes = {
  driverAssignments: PropTypes.array,
  equipmentAssignments: PropTypes.array,
  tagAssignments: PropTypes.array,
  onClickOnEditDrivers: PropTypes.func.isRequired,
  onClickOnEditEquipments: PropTypes.func.isRequired,
  onClickOnEditTags: PropTypes.func.isRequired
};

RouteAssignments.defaultProps = {
  driverAssignments: [],
  equipmentAssignments: [],
  tagAssignments: []
};

export default RouteAssignments;
